import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { xs, sm, md, lg } = constants.breakpoints.BreakpointNames;

export const folderContentsWrapper = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  [mq.between(md, lg)]: {
    maxHeight: "540px",
  },
  [mq.downTo(lg)]: {
    maxHeight: "100%",
  },
};

export const folderContentsHeader = (isTeacherChallengePage = false) => {
  return {
    display: "flex",
    flexDirection: "column",
    width: "100%",

    [mq.downTo(md)]: {
      flexDirection: isTeacherChallengePage ? "row" : "column",
    },
  };
};

export const ViewChallengesButton = {
  display: "flex",
  justifyContent: "center",
  marginBottom: "24px",
  width: "100%",
};

export const buttonsWrapper = {
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  float: "left",

  [mq.downTo(xs)]: {
    flexDirection: "row",
    gap: "16px",
  },
};

export const buttonContainer = {
  width: "100%",
  [mq.downTo(sm)]: {
    width: "49%",
  },
};
